import { RainIcon } from 'app/agriculture/icons';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useDailyRainfall } from 'app/agriculture/hooks/useDailyRainfall/useDailyRainfall';

interface StatDailyRainfallProps {
    deviceId: string;
}

export function StatDailyRainfall({ deviceId }: StatDailyRainfallProps) {
    const rainfall = useDailyRainfall({
        deviceId,
    });

    return (
        <StatDisplay
            id="WeatherButtonRainfallStat"
            Icon={(props) => <RainIcon {...props} title={'Rainfall'} />}
            value={rainfall}
            emptyStateMessage={'--'}
            unit={'mm'}
            decimalPlaces={1}
        />
    );
}
